import { Button, Center, HStack, VStack } from '@starrez/starryui9';
import React from 'react';
import { Text } from '@starryui10/typography/Text';
import { Graphic } from '@starryui10/images/Graphic';

export interface IEmptyStateProps extends global.HashableComponent {
    buttonCaption?: string;
    description?: string;
    graphic: image.SvgVariants;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    showButton?: boolean;
    title: string;
    variant: 'Large' | 'Small';
}

export const EmptyState = ({ buttonCaption, description, graphic, onClick, title, variant, showButton, addHash }: IEmptyStateProps) => {
    if (variant === 'Large') {
        return (
            <VStack gap="small" align="center" justifyContent="center">
                <Center>
                    <Graphic variant={graphic} />
                </Center>
                <Center>
                    <Text textAlign="center" addHash={addHash} renderAs="h4" variant="large.bold">
                        {title}
                    </Text>
                </Center>
                <div style={{ maxWidth: '35ch', margin: '0 auto' }}>
                    <Text textAlign="center" renderAs="p" variant="normal.regular">
                        {description}
                    </Text>
                </div>
                {showButton && (
                    <Center>
                        <Button compact onClick={onClick} variant="Tertiary">
                            {buttonCaption}
                        </Button>
                    </Center>
                )}
            </VStack>
        );
    } else {
        return (
            <HStack gap="medium" sizing="max-content">
                <Center>
                    <Graphic variant={graphic} />
                </Center>
                <VStack gap="xSmall">
                    <div>
                        <Text addHash={addHash} renderAs="h4" variant="large.bold">
                            {title}
                        </Text>
                    </div>
                    <div style={{ maxWidth: '35ch' }}>
                        <Text renderAs="p" variant="normal.regular">
                            {description}
                        </Text>
                    </div>
                    {showButton && (
                        <div>
                            <Button compact onClick={onClick} variant="Tertiary">
                                {buttonCaption}
                            </Button>
                        </div>
                    )}
                </VStack>
            </HStack>
        );
    }
};
